import View from "../../../assets/js/view";
import { css } from "../../../assets/js/utils";
import Flickity from "flickity";
import { breakpoints } from "../../../assets/js/config";

export default class HeroSlider extends View {
  ui = {
    images: ".js-heroImage",
    videoBtn: ".js-heroImageVideoBtn[0]",
    videoOverlays: ".js-heroImageVideoOverlay",
    videoBackdrops: ".js-heroImageVideoBackdrop",
    videoClose: ".js-heroImageVideoClose",
    videoUnmute: ".js-heroVideoUnmute",
    videoMute: ".js-heroVideoMute",
  };

  events = {
    "click @ui.videoBtn": "handleVideoBtnClick",
    "click @ui.videoBackdrops": "handleVideoBackdropBtnClick",
    "click @ui.videoClose": "handleVideoCloseClick",
    "click @ui.videoUnmute": "handleVideoUnMuteClick",
    "click @ui.videoMute": "handleVideoMuteClick",
  };

  init() {
    this.setHeight();
    this.setMarginTop();

    if (this.ui.images.length > 1) {
      const options = this.el.dataset.settings.startsWith("{")
        ? JSON.parse(this.el.dataset.settings)
        : {};
      let flkty = new Flickity(this.el, {
        // options
        autoPlay: options.time ? parseInt(options.time) : 5000,
        pauseAutoPlayOnHover: false,
        fullscreen: true,
        contain: true,
        wrapAround: true,
        pageDots: false,
        prevNextButtons: false,
        selectedAttraction: 0.01,
        friction: 0.25,
      });
    }
  }

  onResize(e) {
    this.setHeight();
    this.setMarginTop();
  }

  setHeight() {
    if (this.isHeightSet) {
      // Reset height
      css(this.ui.images, {
        height: "",
      });
    }

    let height = 0;
    this.ui.images.forEach((el) => {
      let currHeight = el.offsetHeight;
      if (currHeight > height) {
        height = currHeight;
      }
    });
    css(this.ui.images, {
      height: height + "px",
      opacity: "1",
    });
    this.isHeightSet = true;
  }

  setMarginTop() {
    // Reset height
    if (window.innerWidth >= breakpoints.small) {
      css(this.el, {
        marginTop: document.getElementById("nav").offsetHeight + "px",
      });
    } else {
      css(this.el, {
        marginTop: document.querySelector(".nav__head").offsetHeight + "px",
      });
    }

    this.isMarginSet = true;
  }

  handleVideoUnMuteClick(e) {
    //Unmute
    //console.log(e.target.parentElement.parentElement.querySelector('video'));
    //console.log(e.target.nextElementSibling);
    var btnMute = e.target.nextElementSibling;
    var btnUnMute = e.target;
    var video = e.target.parentElement.parentElement.querySelector("video");
    video.muted = false;
    btnUnMute.style.display = "none";
    btnMute.style.display = "block";
    e.preventDefault();
  }

  handleVideoMuteClick(e) {
    //console.log(e.target.previousElementSibling);
    ///Mute
    var btnMute = e.target;
    var btnUnMute = e.target.previousElementSibling;
    var video = e.target.parentElement.parentElement.querySelector("video");
    video.muted = true;
    btnUnMute.style.display = "block";
    btnMute.style.display = "none";
    e.preventDefault();
  }

  handleVideoBtnClick(e) {
    e.currentTarget
      .closest(".js-heroImage")
      ?.querySelector(".js-heroImageVideoOverlay")
      ?.classList.add("is-active");
  }

  handleVideoBackdropBtnClick(e) {
    e.currentTarget.parentElement.classList.remove("is-active");
  }

  handleVideoCloseClick(e) {
    e.currentTarget
      .closest(".js-heroImageVideoOverlay")
      .classList.remove("is-active");
  }
}
